<template>
    <i v-if="isSelected && !isDescending"
       class="fas fa-sort-down table-browser-clickable-icon"
       id="asc-sort"
       title="Sort in descending order"
       @click="updateSort($event.target.id)"
    />

    <i v-else-if="isSelected && isDescending"
       class="fas fa-sort-up table-browser-clickable-icon"
       id="desc-sort"
       title="Sort in ascending order"
       @click="updateSort($event.target.id)"
    />

    <i v-else class="fas fa-sort table-browser-clickable-icon"
       id="not-sort"
       title="Sort in ascending order"
       @click="updateSort($event.target.id)"
    />
</template>

<script>
export default {
    name: "Sort",
    props: {
        initialOrder: {
            type: String,
            required: true
        },

        headerName: {
            type: String,
            required: true
        }
    },

    data: () => ({
        mutableOrder: ""
    }),

    computed: {
        cleanedInitialOrder() {
            // Initial order value contain ANT uuid, need to remove it
            if (this.initialOrder.includes('?')) {
                const temp = this.initialOrder.split("?")
                return temp[0]
            }
            return this.initialOrder
        },

        isSelected() {
            if (this.cleanedInitialOrder.charAt(0) === '-') {
                return this.cleanedInitialOrder.substring(1) === this.headerName
            }
            return this.cleanedInitialOrder === this.headerName
        },

        isDescending() {
            return this.cleanedInitialOrder.charAt(0) === '-'
        },
    },

    methods: {
        updateOrder: function (target) {
            if (target === 'asc-sort') {
                this.mutableOrder = '-' + this.cleanedInitialOrder
            } else if (target === 'desc-sort') {
                this.mutableOrder = this.cleanedInitialOrder.substring(1)
            } else {
                this.mutableOrder = this.headerName
            }
        },

        updateSort: function (target) {
            this.updateOrder(target)
            this.$emit('update-sort', {
                'order': this.mutableOrder,
            })
        }
    }
}
</script>
